/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

// keep private methods here to easily export & test without exposing as public exports
import { IUniversalImport } from '../../interfaces';

export interface IESModule {
    default: Function;
}

// fix until babel-plugin-univeral-import changes go in...
export const fixChunkName = (args: IUniversalImport) => {
    let actualChunkName = args.chunkName();
    // do we have 'the bug' in our named chunk? we can tell because id naming via babel plugin has the same issue
    const matches = /[._]/.exec(args.id);
    const replaceRegEx = /[./_]/gi;
    // if we have a match, should be this..
    if (matches) {
        actualChunkName = actualChunkName.substr(0, matches.index).concat(actualChunkName.substr(matches.index).replace(replaceRegEx, '-'));
    } else {
        actualChunkName = args.id.concat(actualChunkName.substr(args.id.length).replace(replaceRegEx, '-'));
    }

    return actualChunkName;
};

export const getDefaultOrResult = (obj?: IESModule): Function | {} | undefined => (obj && obj.default ? obj.default : obj);
